import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadAddOnsPage),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doPurchaseAddOn),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(watchAddOnsPageSagas);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { fetchEntity, fetchEntityIfNeeded } from '@classpass/saga-tools';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { classBundlesByMsa, purchaseClassBundle, userCreditBalance, userProfile, userSubscription } from 'redux/saga/entities/bound';
import { errorActionCreator } from 'redux/saga/helpers';
import { hideModal } from 'redux/modules/modals';
import { addSuccessNotification } from 'features/Banners/Banners.reducer';
export var PURCHASE_ADD_ON = 'PURCHASE_ADD_ON';
export var LOAD_ADD_ONS_PAGE = 'LOAD_ADD_ONS_PAGE';
export var LOAD_ADD_ONS_PAGE_ERROR = 'LOAD_ADD_ONS_PAGE_ERROR';
export var purchaseAddOn = function purchaseAddOn(options) {
  return _objectSpread({
    type: PURCHASE_ADD_ON
  }, options);
};
export var loadAddOnsPage = function loadAddOnsPage() {
  return {
    type: LOAD_ADD_ONS_PAGE
  };
};
export var loadAddOnsPageError = errorActionCreator.bind(null, LOAD_ADD_ONS_PAGE_ERROR);
export function doLoadAddOnsPage(client) {
  var profile;
  return regeneratorRuntime.wrap(function doLoadAddOnsPage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 3:
          profile = _context.sent;
          _context.next = 6;
          return all([call(fetchEntityIfNeeded, userSubscription, [client, profile.id]), call(fetchEntityIfNeeded, classBundlesByMsa, [client, profile.membership.home_msa_id])]);

        case 6:
          _context.next = 12;
          break;

        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          _context.next = 12;
          return put(loadAddOnsPageError(_context.t0));

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 8]]);
}
export function doPurchaseAddOn(client, _ref) {
  var bundleId, successMessage, profile;
  return regeneratorRuntime.wrap(function doPurchaseAddOn$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          bundleId = _ref.bundleId, successMessage = _ref.successMessage;
          _context2.prev = 1;
          _context2.next = 4;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 4:
          profile = _context2.sent;
          _context2.next = 7;
          return call(fetchEntity, purchaseClassBundle, [client, profile.id, bundleId]);

        case 7:
          _context2.next = 9;
          return call(fetchEntity, userCreditBalance, [client, profile.id]);

        case 9:
          _context2.next = 11;
          return all([put(hideModal('ClassBundleModal')), put(addSuccessNotification(successMessage))]);

        case 11:
          _context2.next = 15;
          break;

        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](1);

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 13]]);
}
export function watchAddOnsPageSagas(client) {
  return regeneratorRuntime.wrap(function watchAddOnsPageSagas$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fork(takeEvery, LOAD_ADD_ONS_PAGE, doLoadAddOnsPage, client);

        case 2:
          _context3.next = 4;
          return fork(takeEvery, PURCHASE_ADD_ON, doPurchaseAddOn, client);

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}